import intro from "./intro.js";
import village from "./village.js";
import hub from "./hub.js";
import island2 from "./island-2.js";
import island3 from "./island-3.js";
import island4 from "./island-4.js";
import island5 from "./island-5.js";
import island6 from "./island-6.js";
import island7 from "./island-7.js";
import island8 from "./island-8.js";
import trial from "./trial.js";

const script = Object.assign(
  {},
  intro,
  village,
  hub,
  island2,
  island3,
  island4,
  island5,
  island6,
  island7,
  island8,
  trial,
);

export default script;



// WEBPACK FOOTER //
// ./src/scripts/script.js